import { render, staticRenderFns } from "./ModuleBalanceLoader.vue?vue&type=template&id=62aab9d1&"
import script from "./ModuleBalanceLoader.vue?vue&type=script&lang=js&"
export * from "./ModuleBalanceLoader.vue?vue&type=script&lang=js&"
import style0 from "./ModuleBalanceLoader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports